import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import { Badge, Coupon, Name } from '../home/card_subscription/main/coupons/item.styles';

import I18nText from '../../../i18n_text';

import { formatNumber, formatPrice } from '../../../../utils/helpers';

import { vendorCardCouponQuery } from '../../../../store';

import { COUPON_BENEFIT_TYPES } from '../../../../constants';

import type { Coupon as CouponType } from '@rewardopl/types';

type CouponItemProps = {
  couponId: CouponType['_id'];
};

export default function CouponItem({ couponId }: CouponItemProps) {
  const coupon = useAtomValue(vendorCardCouponQuery(couponId));

  const { benefits, name, name_i18n: nameI18n } = coupon;

  const isLongBadge = benefits.type === COUPON_BENEFIT_TYPES.STAMP_AMOUNT;

  return (
    <Coupon>
      <Badge isLong={isLongBadge}>
        {(() => {
          const { type: benefitsType } = benefits;

          switch (benefitsType) {
            case COUPON_BENEFIT_TYPES.DISCOUNT_AMOUNT:
              return `-${formatPrice(benefits.amount, benefits.currency)}`;
            case COUPON_BENEFIT_TYPES.DISCOUNT_PERCENTAGE:
              return `-${benefits.percentage}%`;
            case COUPON_BENEFIT_TYPES.STAMP_AMOUNT:
              return (
                <>
                  {formatNumber(benefits.amount)} <T>lajkoniks</T>
                </>
              );
            case COUPON_BENEFIT_TYPES.STAMP_MULTIPLY:
              return `${benefits.multiplier}×`;
            case COUPON_BENEFIT_TYPES.FREEBIE:
              return <T>freebie</T>;
            default:
              throw new Error(`Invalid coupon benefits type: ${benefitsType satisfies never}`);
          }
        })()}
      </Badge>
      <Name>
        <I18nText fallbackValue={name} value={nameI18n} />
      </Name>
    </Coupon>
  );
}
